var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('div',{staticClass:"font-weight-bolder"},[_vm._v(" "+_vm._s(_vm.agentName || _vm.brandName || _vm.manufacturerName || 'Ave Valley')+" ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }